var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutogestionAcademica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187 187",
    width: 187,
    height: 187,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "manejo_tiempo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #d8a568 } \n\t\t.s1 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Segunda_pantalla"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m24.6 8h122.9c9.2 0 16.6 7.4 16.6 16.6v122.9c0 9.2-7.4 16.6-16.6 16.6h-122.9c-9.1 0-16.6-7.4-16.6-16.6v-122.9c0-9.2 7.5-16.6 16.6-16.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Segunda_pantalla-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "s1",
    fontFamily: "sans-serif",
    fontSize: 10,
    textAnchor: "middle",
    x: 84.6,
    y: 124
  }, "Autogesti&#243;n"), /*#__PURE__*/React.createElement("text", {
    className: "s1",
    fontFamily: "sans-serif",
    fontSize: 10,
    textAnchor: "middle",
    x: 84.6,
    y: 138
  }, "acad&#233;mica")), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m49.2 63.7c0-17.8 13.2-32.6 30.4-35-0.4-0.7-0.6-1.6-0.6-2.5 0-3.2 2.5-5.7 5.6-5.7 3.2 0 5.7 2.5 5.7 5.7 0 0.9-0.2 1.8-0.6 2.6 17 2.5 30.1 17.2 30.1 34.9 0 19.5-15.8 35.3-35.3 35.3-19.5 0-35.3-15.8-35.3-35.3zm35.3 35.3q0 0 0 0zm-1.8-72.8c0 1 0.9 1.9 1.9 1.9 1.1 0 1.9-0.9 1.9-1.9 0-1.1-0.8-1.9-1.9-1.9-1 0-1.9 0.8-1.9 1.9zm-29.8 37.5c0 17.4 14.2 31.6 31.6 31.6 17.4 0 31.5-14.2 31.5-31.6 0-17.4-14.1-31.5-31.5-31.5-17.4 0-31.6 14.1-31.6 31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m58.3 63.7c0-14.4 11.8-26.1 26.2-26.1 14.4 0 26.1 11.7 26.1 26.1 0 14.4-11.7 26.2-26.1 26.2-14.4 0-26.2-11.8-26.2-26.2zm26.2-23.1c-12.8 0-23.2 10.3-23.2 23.1 0 12.8 10.4 23.2 23.2 23.2 12.8 0 23.1-10.4 23.1-23.2 0-12.8-10.4-23.1-23.1-23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m62.4 63.7c0 0.4 0.3 0.8 0.7 0.8h5.6c0.4 0 0.8-0.4 0.8-0.8 0-0.4-0.4-0.7-0.8-0.7h-5.6c-0.4 0-0.7 0.3-0.7 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m100.6 64.5h5.6c0.4 0 0.7-0.4 0.7-0.8 0-0.4-0.3-0.7-0.7-0.7h-5.6c-0.4 0-0.8 0.3-0.8 0.7 0 0.4 0.4 0.8 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m84.6 48.5c0.5 0 0.8-0.3 0.8-0.7v-5.6c0-0.4-0.4-0.7-0.8-0.7-0.4 0-0.7 0.3-0.7 0.7v5.6c0 0.4 0.3 0.7 0.7 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m84.6 78.9c-0.4 0-0.7 0.3-0.7 0.8v5.5c0 0.4 0.3 0.8 0.7 0.8 0.5 0 0.8-0.4 0.8-0.8v-5.5c0-0.5-0.4-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m85.2 59.6h0.2l-0.7-9.4-1.1 9.5c-1.8 0.5-3.1 2.1-3.1 4 0 2.3 1.8 4.2 4.1 4.2 2.3 0 4.2-1.9 4.2-4.2 0-2.1-1.6-3.8-3.6-4.1q0 0 0 0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutogestionAcademica);
export default __webpack_public_path__ + "static/media/autogestion_academica.6b7a7fe0d53624121015b238662fbaae.svg";
export { ForwardRef as ReactComponent };